import { sample } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import { trackEvent } from 'global-utils/Analytics'
import { Emoji } from 'images'

import { authAction } from 'actions/AuthActions'

import './index.css'

class RegisterNow extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      closed: false,
      info: !props.delay && sample(this.optionsList),
    }
    this.interval = null
  }

  componentDidMount() {
    this.interval = this.props.delay
      ? setTimeout(this.changeInfo, this.props.delay * 1000)
      : setTimeout(this.changeInfo, this.props.intervalTime * 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.interval)
  }

  changeInfo = () => {
    clearTimeout(this.interval)

    this.setState({
      info: sample(this.optionsList),
    })

    this.interval = setTimeout(this.changeInfo, this.props.intervalTime * 1000)
  }

  close = () => {
    this.setState({
      closed: true,
    })
    clearTimeout(this.interval)
  }

  onCloseClick = () => {
    trackEvent('Component', 'Click', 'Register Now - Close Button')
    this.close()
  }

  onLoginClick = () => {
    trackEvent('Component', 'Click', 'Register Now - Login Button')
    this.props.authAction('login')
    this.close()
  }

  onRegisterClick = () => {
    trackEvent('Component', 'Click', 'Register Now - Register Button')
    this.props.authAction('register')
    this.close()
  }

  optionsList = [
    <span key="goal">
      &nbsp;&nbsp;
      <Emoji name="goal_net" />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Emoji name="soccer" />
      <Emoji name="runner" />
      <Emoji name="dash" />
      &nbsp;&nbsp;...&nbsp;&nbsp;<b>¡¿GOL?!</b>
      <br />
      Tú puedes ajustar los marcadores.
    </span>,
    <span key="follow">
      &nbsp;&nbsp;&nbsp;
      <Emoji name="man-raising-hand" />
      &nbsp;
      <Emoji name="man-girl-boy" />
      &nbsp;
      <Emoji name="baby" />
      &nbsp;
      <Emoji name="woman-girl-boy" />
      &nbsp;
      <Emoji name="woman-raising-hand" />
      <br />
      ¿Quieres seguir a tu equipo?.
    </span>,
    <span key="stats">
      &nbsp;
      <Emoji name="nerd_face" />
      &nbsp;
      <Emoji name="memo" />
      &nbsp;
      <Emoji name="bar_chart" />
      <br />
      Te gustan las estadísticas...
    </span>,
    <span key="notifications">
      ¿Olvidas tus partidos?
      <br />
      Nosotros te notificamos &nbsp;&nbsp;
      <Emoji name="bell" />
      &nbsp;&nbsp;
      <Emoji name="calendar" />
    </span>,
    <span key="thoughts">
      &nbsp;&nbsp;
      <Emoji name="megaman" />
      &nbsp;&nbsp;
      <Emoji name="imp" />
      &nbsp;&nbsp;
      <Emoji name="walking_dead" />
      &nbsp;&nbsp;
      <Emoji name="rage" />
      &nbsp;&nbsp;
      <Emoji name="sleeping" />
      <br />
      Comparte tus pensamientos del partido.
    </span>,
    <span key="referee">
      &nbsp;&nbsp;
      <Emoji name="cop" />
      &nbsp;&nbsp;
      <Emoji name="star" />
      &nbsp;
      <Emoji name="star" />
      &nbsp;
      <Emoji name="star" />
      &nbsp;
      <Emoji name="star" />
      &nbsp;
      <Emoji name="star" />
      <br />
      Califica el arbitraje.
    </span>,
  ]

  render() {
    const { user } = this.props
    const { closed, info } = this.state

    if (user || closed || !info) {
      return null
    }

    return (
      <div className="RegisterNow">
        <div className="RegisterNow__holder">
          <div className="RegisterNow__holder__content">
            <Button icon="close" onClick={this.onCloseClick} size="mini" />
            {info}
            <div>
              <a
                className="text-green"
                href="#register"
                onClick={this.onRegisterClick}
                onKeyPress={this.onRegisterClick}
                role="button"
              >
                Regístrate
              </a>
              {' o '}
              <a
                className="text-green"
                href="#login"
                onClick={this.onLoginClick}
                onKeyPress={this.onLoginClick}
                role="button"
              >
                Ingresa.
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

RegisterNow.propTypes = {
  authAction: PropTypes.func.isRequired,
  delay: PropTypes.number,
  intervalTime: PropTypes.number,
  user: PropTypes.object,
}

RegisterNow.defaultProps = {
  delay: 10,
  intervalTime: 7,
  user: null,
}

export class Pure extends RegisterNow {}

export default connect(({ auth: { usr: user } }) => ({ user }), { authAction })(RegisterNow)
